// Introduction workflow settings (PRODUCT.md "Open items"). Stored in
// `ranking_config` under key 'workflow'; curator-editable later.
import { z } from 'zod';

export const workflowConfigSchema = z.object({
  /** Days a company has to mark cards interested/pass before curators may introduce all consenting candidates. */
  reactionWindowDays: z.number().int().min(1).max(30),
  /** Days a consent link stays valid. */
  consentTokenDays: z.number().int().min(1).max(60),
});
export type WorkflowConfig = z.infer<typeof workflowConfigSchema>;

export const DEFAULT_WORKFLOW_CONFIG: WorkflowConfig = {
  reactionWindowDays: 5,
  consentTokenDays: 14,
};

export const consentAnswerSchema = z.object({
  token: z.string().min(20).max(200),
  answer: z.enum(['yes', 'no']),
});

export const companyReactionInputSchema = z.object({
  reaction: z.enum(['interested', 'pass']),
});
